type ISliderNavigationProps = {
    total: number
    activeIndex: number
    onChange: (index: number) => void
    style?: 'white' | 'dark'
}

export const SliderNavigation = ({
    total,
    activeIndex,
    onChange,
    style = 'white',
}: ISliderNavigationProps) => {
    const handlePrev = () => {
        if (activeIndex > 0) onChange(activeIndex - 1)
    }

    const handleNext = () => {
        if (activeIndex < total - 1) onChange(activeIndex + 1)
    }

    const styles = {
        white: {
            btn: 'bg-white',
            btnDisabled: 'bg-white/10',
            dot: 'bg-white/10',
            dotActive: 'bg-white',
        },
        dark: {
            btn: 'bg-black text-white',
            btnDisabled: 'bg-[#08180F]/10 text-white',
            dot: 'bg-[#08180F]/10',
            dotActive: 'bg-black',
        },
    }

    const current = styles[style]

    return (
        <div className="flex items-center justify-center">
            <button
                onClick={handlePrev}
                disabled={activeIndex === 0}
                className={`
                    flex items-center justify-center p-2 mr-4
                    w-[42px] h-[42px] rounded-2xl transition
                    ${activeIndex === 0 ? current.btnDisabled : current.btn}
                `}
            >
                <svg
                    width="26"
                    height="26"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    fill="none"
                    strokeWidth="2"
                >
                    <polyline
                        points="15 6 9 12 15 18"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            </button>

            <div className="flex items-center gap-3">
                {Array.from({ length: total }).map((_, idx) => (
                    <button
                        key={idx}
                        onClick={() => onChange(idx)}
                        className={`
                            w-2 h-2 rounded-full transition
                            ${idx === activeIndex ? `${current.dotActive} scale-110` : current.dot}
                        `}
                    />
                ))}
            </div>

            <button
                onClick={handleNext}
                disabled={activeIndex === total - 1}
                className={`
                    flex items-center justify-center p-2 ml-4
                    w-[42px] h-[42px] rounded-2xl transition
                    ${activeIndex === total - 1 ? current.btnDisabled : current.btn}
                `}
            >
                <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                    <path d="M12.424 10.0008L5.58691 3.16372L6.91274 1.83789L15.0757 10.0008L6.91274 18.1637L5.58691 16.8379L12.424 10.0008Z" />
                </svg>
            </button>
        </div>
    )
}
